import React, { useState, useEffect } from 'react';
import branchService from '../api/branchService';
import Swal from 'sweetalert2';
import AddBranchModal from './AddBranchModal'; // Import the modal
import EditBranchModal from './EditBranchModal'; // Import the edit modal
import './BranchManagementPage.css';

function BranchManagementPage() {
  const [branches, setBranches] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [newBranch, setNewBranch] = useState({
    headquarters: '',
    name: '',
    representative: '',
    address: '',
  });
  const [editingBranch, setEditingBranch] = useState(null);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      const response = await branchService.getBranches();
      setBranches(response.data);
    } catch (error) {
      console.error('Failed to fetch branches:', error);
    }
  };

  const handleAddBranch = async (e) => {
    e.preventDefault();
    try {
      await branchService.addBranch(newBranch);
      fetchBranches(); // Refresh the list
      setIsAddModalOpen(false); // Close modal on success
      setNewBranch({ headquarters: '', name: '', representative: '', address: '' }); // Reset form
    } catch (error) {
      console.error('Failed to add branch:', error);
    }
  };

  const handleEditBranch = (branch) => {
    setEditingBranch(branch);
    setIsEditModalOpen(true);
  };

  const handleUpdateBranch = async (e) => {
    e.preventDefault();
    if (!editingBranch) return;

    try {
      await branchService.updateBranch(editingBranch.id, editingBranch);
      fetchBranches();
      setIsEditModalOpen(false);
      setEditingBranch(null);
      Swal.fire(
        '수정 완료!',
        '지사 정보가 성공적으로 수정되었습니다.',
        'success'
      );
    } catch (error) {
      console.error('Failed to update branch:', error);
      Swal.fire(
        '수정 실패',
        '지사 정보 수정 중 오류가 발생했습니다.',
        'error'
      );
    }
  };

  const handleDeleteBranch = async (branchId) => {
    const result = await Swal.fire({
      title: '정말로 삭제하시겠습니까?',
      text: "삭제된 데이터는 복구할 수 없습니다.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: '삭제',
      cancelButtonText: '취소'
    });

    if (result.isConfirmed) {
      try {
        await branchService.deleteBranch(branchId);
        fetchBranches(); // Refresh the list
        Swal.fire(
          '삭제 완료!',
          '지사 정보가 성공적으로 삭제되었습니다.',
          'success'
        );
      } catch (error) {
        console.error('Failed to delete branch:', error);
        Swal.fire(
          '삭제 실패',
          '지사 정보 삭제 중 오류가 발생했습니다.',
          'error'
        );
      }
    }
  };

  return (
    <div className="branch-management-container">
      <h1>지사 관리</h1>
      
      <div className="branch-actions">
        <button onClick={() => setIsAddModalOpen(true)} className="add-branch-button">신규 등록</button>
      </div>

      <AddBranchModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onAddBranch={handleAddBranch}
        branchData={newBranch}
        setBranchData={setNewBranch}
      />

      {editingBranch && (
        <EditBranchModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          onUpdateBranch={handleUpdateBranch}
          branchData={editingBranch}
          setBranchData={setEditingBranch}
        />
      )}

      <div className="branch-list-container">
        <h2>지사 목록</h2>
        <table className="branch-table">
          <thead>
            <tr>
              <th>본부</th>
              <th>지사명</th>
              <th>대표자</th>
              <th>주소</th>
              <th>관리</th>
            </tr>
          </thead>
          <tbody>
            {branches.map((branch) => (
              <tr key={branch.id}>
                <td>{branch.headquarters}</td>
                <td>{branch.name}</td>
                <td>{branch.representative}</td>
                <td>{branch.address}</td>
                <td>
                  <button onClick={() => handleEditBranch(branch)} className="edit-btn">수정</button>
                  <button onClick={() => handleDeleteBranch(branch.id)} className="delete-btn">삭제</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BranchManagementPage;
